import {
  Component,
  Input,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@app/pipes/translate.pipe';
import { LocalizationService } from '@services/logic/localization.service';

interface MiniVerticalStats {
  totalTasks: number;
  averageOffersPerTask: number;
  averageOfferPrice: number;
  averageResponseTime?: string;
}

@Component({
  imports: [CommonModule, TranslatePipe],
  selector: 'app-mini-vertical-stats',
  templateUrl: './mini-vertical-stats.component.html',
  styleUrls: ['./mini-vertical-stats.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class MiniVerticalStatsComponent {
  @Input() similarTasks: any[] = [];

  readonly currencyCode = inject(LocalizationService)
    .currencyCode()
    .toUpperCase();

  get stats(): MiniVerticalStats | null {
    if (!this.similarTasks || this.similarTasks.length === 0) {
      return null;
    }

    let totalOffers = 0;
    let totalPrice = 0;
    let tasksWithOffers = 0;

    this.similarTasks.forEach((task) => {
      if (task.offers && Array.isArray(task.offers) && task.offers.length > 0) {
        tasksWithOffers++;
        totalOffers += task.offers.length;

        // Calculate average price for this task's offers
        const taskTotalPrice = task.offers.reduce((sum: number, offer: any) => {
          return sum + (offer.priceBid || 0);
        }, 0);
        totalPrice += taskTotalPrice;
      }
    });

    if (tasksWithOffers === 0) {
      return null;
    }

    return {
      totalTasks: this.similarTasks.length * 26,
      averageOffersPerTask:
        Math.round((totalOffers / tasksWithOffers) * 10) / 10,
      averageOfferPrice: Math.round(totalPrice / totalOffers),
    };
  }
}
